module.exports = __webpack_public_path__ + "img/order-qt.d488372e.png";